import React from 'react';

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: 'filled-primary' | 'filled-primary-rounded' | 'bordered-primary' | 'danger' | 'google' | 'bordered-danger' | 'back';
  children: React.ReactNode;
  onClick?: (() => void) | ((e: React.FormEvent) => Promise<void>);
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({ 
  type = 'button',
  disabled = false,
  variant = 'filled-primary', 
  children, 
  onClick, 
  className = '' 
}) => {
  const baseClasses = 'px-4 py-2 rounded-lg transition-colors duration-300 font-sora';
  
  const variantClasses = {
    'filled-primary': 'bg-primary text-white ',
    'filled-primary-rounded': 'bg-primary text-light  rounded-full',
    'bordered-primary': 'border border-primary text-primary hover:bg-primary hover:text-white',
    'danger': 'bg-danger text-light hover:bg-danger_dark',
    'google': 'bg-light text-dark border border-grey_light hover:bg-bg_grey_light',
    'bordered-danger': 'border border-danger text-danger hover:bg-danger hover:text-light',
    'back': 'bg-transparent border border-primary_variant text-dark rounded hover:bg-bg_grey_light px-2 py-0',
  };

  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
